// Mock data for Cresence Skin Care Clinic

export const mockData = {
  clinic: {
    short_name: "Cresence Skin",
    name: "Cresence Skin Clinic",
    tagline: "Glow Begins Here",
    address:
      "112/113 Avadh Viceroy, Sarthana Jakatnaka, Surat, Gujarat - 395006",
    phone: "+91 74900 20099",
    whatsapp: "+91 74900 20099",
    email: "contact@cresence.skin",
    timings: {
      weekdays: "10:00 AM - 7:00 PM",
      saturday: "10:00 AM - 7:00 PM",
      sunday: "Closed",
    },
    googleRating: 4.9,
    location: {
      lat: 21.2311515,
      lng: 72.903189,
    },
  },

  doctor: {
    name: "Dr. Nisha Mavani",
    qualification: "PGDFAC , BHMS",
    experience: "15+ years",
    specialization: "Facial Aesthetic & Glow Expert",
    image:
      "https://images.unsplash.com/photo-1706565029539-d09af5896340?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxkZXJtYXRvbG9naXN0fGVufDB8fHx8MTc1MjY2ODY4Mnww&ixlib=rb-4.1.0&q=85",
    bio: "With qualifications in BHMS and PGDFAC, I provide expert care for skin, hair, and aesthetics-grounded in medical science and real-world experience. I believe beauty begins with confidence, and my goal is to create a welcoming space where every client feels truly understood, respected, and supported.",
  },

  treatmentPackages: [
    {
      combo: "Q Switch + Cosmelas Pro Peel",
      package_name: "Pigment Reset Duo",
      focus_area: "Deep pigmentation/melasma",
      sessions: {
        1: 5600,
        3: 16500,
        "6+1": 33000,
        "10+2": 55000,
      },
    },
    {
      combo: "Q Switch + Cosmelas Pro Peel",
      package_name: "Breakout Blaster Duo",
      focus_area: "Acne marks + active acne",
      sessions: {
        1: 4700,
        3: 14100,
        "6+1": 28200,
        "10+2": 47000,
      },
    },
    {
      combo: "Q Switch + Acne Act Peel",
      package_name: "Glow Awakening Duo",
      focus_area: "Mild tan, glow, first timers",
      sessions: {
        1: 4700,
        3: 12900,
        "6+1": 25800,
        "10+2": 43000,
      },
    },
    {
      combo: "Q Switch + Lactic Peel 40%",
      package_name: "Bright Eye Duo",
      focus_area: "Dark circles, under-eye dullness",
      sessions: {
        1: 5000,
        3: 15000,
        "6+1": 30000,
        "10+2": 50000,
      },
    },
    {
      combo: "Q Switch + Under Eye Peel",
      package_name: "Event Ready Duo",
      focus_area: "Pre-party glow, special events",
      sessions: {
        1: 4700,
        3: 14100,
        "6+1": 28200,
        "10+2": 47000,
      },
    },
    {
      combo: "Q Switch + Party Peel",
      package_name: "Pore Purify Duo",
      focus_area: "Oily skin, blackheads, acne-prone skin",
      sessions: {
        1: 4700,
        3: 14100,
        "6+1": 28200,
        "10+2": 47000,
      },
    },
    {
      combo: "Fractional + Q Switch + Cosmelas Pro Peel",
      package_name: "Pigment Reset Trilogy",
      focus_area: "Strong pigmentation/melasma",
      sessions: {
        1: 9000,
        3: 27000,
        "6+1": 54000,
        "10+2": 82000,
      },
    },
    {
      combo: "Fractional + Q Switch + Acne Act Peel",
      package_name: "Scar Repair Trilogy",
      focus_area: "Strong scars + red marks",
      sessions: {
        1: 8200,
        3: 24600,
        "6+1": 49200,
        "10+2": 82000,
      },
    },
    {
      combo: "Fractional + Cosmelas Pro Peel",
      package_name: "EvenTones Ritual",
      focus_area: "Deep pigment + texture correction",
      sessions: {
        1: 5600,
        3: 14100,
        "6+1": 28200,
        "10+2": 47000,
      },
    },
  ],

  treatments: [
    {
      id: 1,
      name: "Acne & Acne-Scar Treatment",
      description:
        "Targeted treatment for acne and post-acne scars to restore smooth, clear skin.",
      price: "₹3,500",
      duration: "60 mins",
      image: "./images/Acne_Scar_Treatment.png",
    },
    {
      id: 2,
      name: "Skin Rejuvenation & Glow Treatment",
      description:
        "Revives skin radiance with deep hydration and gentle exfoliation.",
      price: "₹2,800",
      duration: "50 mins",
      image: "./images/Skin_Rejuvenation_Treatment.png",
    },
    {
      id: 3,
      name: "Pigmentation & Dark-Spot Correction",
      description:
        "Fades dark spots and evens skin tone using advanced pigmentation therapies.",
      price: "₹3,200",
      duration: "55 mins",
      image: "./images/Pigmentation_Correction.png",
    },
    {
      id: 4,
      name: "Laser Hair Reduction",
      description:
        "Painless laser treatment for long-lasting hair reduction on targeted areas.",
      price: "₹2,500",
      duration: "45 mins",
      image: "./images/Laser_Hair_Reduction.png",
    },
    {
      id: 5,
      name: "Anti-Aging Treatment",
      description:
        "Smooths fine lines and boosts collagen for youthful, firmer skin.",
      price: "₹4,000",
      duration: "60 mins",
      image: "./images/Anti_Aging_Treatment.png",
    },
    {
      id: 6,
      name: "Customized Facials & Peels",
      description:
        "Personalized facial and peel combos tailored to your skin’s unique needs.",
      price: "₹3,000",
      duration: "50 mins",
      image: "./images/Customized_Facial_Treatment.png",
    },
    {
      id: 7,
      name: "Mole & Skin-Tag Removal",
      description:
        "Safe removal of moles and skin tags using precision dermatological technique.",
      price: "₹1,800",
      duration: "30 mins",
      image: "./images/Mole_Removal_Procedure.png",
    },
    {
      id: 8,
      name: "Hair Growth Treatment",
      description:
        "Stimulates hair regrowth and strengthens follicles for fuller coverage.",
      price: "₹3,600",
      duration: "60 mins",
      image: "./images/Hair_Growth_Treatment.png",
    },
    {
      id: 9,
      name: "Wellness Counseling with Skin Focus",
      description:
        "Holistic skin-care counseling merging wellness and dermatological insights.",
      price: "₹2,400",
      duration: "40 mins",
      image: "./images/Skin_Wellness_Counseling.png",
    },
    {
      id: 10,
      name: "Tattoo Removal",
      description:
        "Advanced laser-based removal of unwanted tattoos with minimal scarring.",
      price: "₹4,500",
      duration: "70 mins",
      image: "./images/Tattoo_Removal_Procedure.png",
    },
  ],

  beforeAfterImages: [
    {
      id: 1,
      title: "Acne Treatment Results",
      before: "https://images.unsplash.com/photo-1613223026022-afda5c1c95b8",
      after: "https://images.unsplash.com/photo-1730288951113-9cc087c14b83",
    },
    {
      id: 2,
      title: "Skin Rejuvenation",
      before: "https://images.unsplash.com/photo-1734120273696-596f96658db9",
      after:
        "https://images.pexels.com/photos/29021130/pexels-photo-29021130.jpeg",
    },
    {
      id: 3,
      title: "Anti-Aging Treatment",
      before:
        "https://images.pexels.com/photos/3985314/pexels-photo-3985314.jpeg",
      after: "https://images.unsplash.com/photo-1575433287483-8ec588f72417",
    },
  ],

  testimonials: [
    {
      id: 1,
      name: "Riya Patel",
      image: "https://images.unsplash.com/photo-1575433287483-8ec588f72417",
      rating: 5,
      review:
        "Amazing results! Dr. Nisha's acne treatment completely transformed my skin. The clinic is very professional and hygienic.",
      treatment: "Acne Treatment",
    },
    {
      id: 2,
      name: "Amit Shah",
      image: "https://images.unsplash.com/photo-1734120273696-596f96658db9",
      rating: 5,
      review:
        "Best laser hair removal experience in Surat. The staff is friendly and the results are excellent.",
      treatment: "Laser Hair Removal",
    },
    {
      id: 3,
      name: "Neha Gupta",
      image: "https://images.unsplash.com/photo-1730288951113-9cc087c14b83",
      rating: 5,
      review:
        "PRP therapy gave me the glow I was looking for. Highly recommend Cresence Skin Care Clinic!",
      treatment: "PRP Therapy",
    },
  ],

  whyChooseUs: [
    {
      id: 1,
      title: "Certified Treatments",
      description:
        "Government-certified cosmetologists ensuring safe, effective, and professional treatments with proven expertise.",
      icon: "Award",
    },
    {
      id: 2,
      title: "FDA-Approved Machines",
      description:
        "We use only the latest FDA-approved equipment for all treatments",
      icon: "Shield",
    },
    {
      id: 3,
      title: "Personalized Plans",
      description:
        "Every treatment is customized to your specific skin needs and goals",
      icon: "User",
    },
    {
      id: 4,
      title: "4.9⭐ Rating on Google",
      description:
        "Trusted by hundreds of satisfied patients with excellent reviews",
      icon: "Star",
    },
  ],

  instagramPosts: [
    {
      id: 1,
      image:
        "https://images.unsplash.com/photo-1676312754401-d97fe43c2c4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxkZXJtYXRvbG9naXN0fGVufDB8fHx8MTc1MjY2ODY4Mnww&ixlib=rb-4.1.0&q=85",
      caption: "Professional skin analysis with our advanced equipment ✨",
      likes: 156,
      comments: 23,
    },
    {
      id: 2,
      image:
        "https://images.unsplash.com/photo-1601839777132-b3f4e455c369?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxza2luY2FyZSUyMGNsaW5pY3xlbnwwfHx8fDE3NTI2Njg2NzJ8MA&ixlib=rb-4.1.0&q=85",
      caption: "Dr. Nisha explaining the benefits of PRP therapy 🧬",
      likes: 89,
      comments: 12,
    },
    {
      id: 3,
      image:
        "https://images.pexels.com/photos/29021130/pexels-photo-29021130.jpeg",
      caption: "Glowing skin after our signature facial treatment 🌟",
      likes: 203,
      comments: 34,
    },
    {
      id: 4,
      image:
        "https://images.pexels.com/photos/3985314/pexels-photo-3985314.jpeg",
      caption: "Behind the scenes of our advanced skincare treatments 💆‍♀️",
      likes: 67,
      comments: 8,
    },
  ],

  offers: [
    {
      id: 1,
      title: "Signature Glow Combo",
      originalPrice: "₹3,700",
      discountedPrice: "₹1299",
      discount: "65% OFF",
      duration: "60 mins",
      includes: ["Signature hydra facial", "Lactic peel"],
      validTill: "30st September 2025",
    },
    {
      id: 2,
      title: "Clear Skin Acne Care ",
      originalPrice: "₹1,600",
      discountedPrice: "₹999",
      discount: "37% OFF",
      duration: "3 sessions",
      includes: ["Deep Clean up", "Acne Peel ", "Light Therapy"],
      validTill: "30st September 2025",
    },
    {
      id: 3,
      title: "Laser Hair Removal Trio ",
      originalPrice: "₹14,350",
      discountedPrice: "₹7,999",
      discount: "45% OFF",
      duration: "7 sessions",
      includes: ["Upper lips", "Underarms", "Bikini", "7-sessions"],
      validTill: "30st September 2025",
    },
  ],

  faqs: [
    {
      id: 1,
      question:
        "What makes Cresence Skin Care Clinic different from other clinics?",
      answer:
        "We offer personalized treatment plans using FDA-approved equipment with board-certified cosmetologists. 4.9⭐ Google rating reflect our commitment to exceptional care and results.",
    },
    {
      id: 2,
      question: "Are the treatments safe and do they have any side effects?",
      answer:
        "All our treatments are performed by certified cosmetologists using FDA-approved equipment. We follow strict safety protocols and conduct thorough consultations to minimize any risks. Minor side effects like temporary redness may occur but subside quickly.",
    },
    {
      id: 3,
      question: "How many sessions will I need for visible results?",
      answer:
        "The number of sessions varies based on your skin condition and treatment type. Most patients see visible improvements after 1-3 sessions. During your consultation, our cosmetologist will create a personalized treatment plan with expected timelines.",
    },
    {
      id: 4,
      question:
        "What is the difference between Duo, Trilogy, and Ritual packages?",
      answer:
        "Duo packages combine 2 treatments (Q Switch + Peel), Trilogy packages include 3 treatments (Fractional + Q Switch + Peel), and Ritual packages combine 2 treatments (Fractional + Peel). Each targets specific skin concerns with varying intensity levels.",
    },
    {
      id: 5,
      question: "Can I get a consultation before deciding on a treatment?",
      answer:
        "Yes! We offer free consultations where our cosmetologist will assess your skin, discuss your concerns, and recommend the best treatment plan for your specific needs. You can book online or call us directly.",
    },
    {
      id: 6,
      question: "What should I expect during my first visit?",
      answer:
        "During your first visit, our cosmetologist will conduct a comprehensive skin analysis, discuss your medical history, understand your skin goals, and recommend suitable treatments. We'll also provide detailed information about the process and aftercare.",
    },
    {
      id: 7,
      question: "Do you offer payment plans or EMI options?",
      answer:
        "No, we currently do not offer EMI or installment payment plans. However, you can pay through various available methods such as cash, cards, or digital payments.",
    },
    {
      id: 8,
      question: "How do I prepare for my treatment session?",
      answer:
        "Preparation varies by treatment type. Generally, avoid sun exposure, certain medications, and skincare products as advised. We'll provide detailed pre-treatment instructions during your consultation to ensure optimal results.",
    },
  ],

  blogPosts: [
    {
      id: 1,
      title: "Understanding Different Types of Chemical Peels",
      excerpt:
        "Discover the benefits of various chemical peels and how they can transform your skin texture and appearance.",
      image:
        "https://images.unsplash.com/photo-1700760933574-9f0f4ea9aa3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxza2luY2FyZSUyMGNsaW5pY3xlbnwwfHx8fDE3NTI2Njg2NzJ8MA&ixlib=rb-4.1.0&q=85",
      date: "January 15, 2025",
      category: "Treatments",
      readTime: "5 min read",
    },
    {
      id: 2,
      title: "The Science Behind Q Switch Laser Technology",
      excerpt:
        "Learn how Q Switch laser technology works and why it's effective for pigmentation and tattoo removal.",
      image:
        "https://images.unsplash.com/photo-1700760933941-3a06a28fbf47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxza2luY2FyZSUyMGNsaW5pY3xlbnwwfHx8fDE3NTI2Njg2NzJ8MA&ixlib=rb-4.1.0&q=85",
      date: "January 10, 2025",
      category: "Technology",
      readTime: "7 min read",
    },
    {
      id: 3,
      title: "Bridal Skincare: Your Complete Pre-Wedding Guide",
      excerpt:
        "Essential skincare tips and treatment timeline for achieving perfect bridal glow for your special day.",
      image:
        "https://images.pexels.com/photos/5069432/pexels-photo-5069432.jpeg",
      date: "January 8, 2025",
      category: "Skincare Tips",
      readTime: "6 min read",
    },
    {
      id: 4,
      title: "Acne Scarring: Prevention and Treatment Options",
      excerpt:
        "Comprehensive guide to preventing acne scars and modern treatment options for existing scarring.",
      image:
        "https://images.pexels.com/photos/4586711/pexels-photo-4586711.jpeg",
      date: "January 5, 2025",
      category: "Acne Care",
      readTime: "8 min read",
    },
    {
      id: 5,
      title: "Seasonal Skincare: Adapting Your Routine",
      excerpt:
        "How to adjust your skincare routine for different seasons and weather conditions in Surat.",
      image:
        "https://images.pexels.com/photos/29021130/pexels-photo-29021130.jpeg",
      date: "January 2, 2025",
      category: "Skincare Tips",
      readTime: "4 min read",
    },
    {
      id: 6,
      title: "Understanding Melasma: Causes and Treatment",
      excerpt:
        "Deep dive into melasma causes, prevention strategies, and effective treatment combinations.",
      image:
        "https://images.unsplash.com/photo-1676312754401-d97fe43c2c4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxkZXJtYXRvbG9naXN0fGVufDB8fHx8MTc1MjY2ODY4Mnww&ixlib=rb-4.1.0&q=85",
      date: "December 28, 2024",
      category: "Pigmentation",
      readTime: "6 min read",
    },
  ],
};
